import { AccountsOrderBy, Order } from "./types";

export const orderByOrder: Record<AccountsOrderBy, Order> = {
  "name": "asc",
  "category": "asc",
  "status": "asc",
  "createdAt": "desc",
  "updatedAt": "desc",
};
